import React, { type FC, useCallback, useRef, useState } from 'react';
import Snackbar from '@mui/material/Snackbar';
import Alert from '@mui/material/Alert';
import { ToastContext, type ToastMessage} from './ToastContext';

type SnackbarToastProps = {
    children: React.ReactNode;
};

const SnackbarToast: FC<SnackbarToastProps> = ({ children }) => {
    const [toasts, setToasts] = useState<ToastMessage[]>([]);
    const nextToastIdRef = useRef(1);

    const addToast = useCallback((message: ToastMessage) => {
        const toastWithId: ToastMessage = {
            ...message,
            id: nextToastIdRef.current++
        };
        setToasts((prevToasts) => [...prevToasts, toastWithId]);
    }, []);

    const handleCloseSnackbar = useCallback((id: number) => {
        setToasts((prevToasts) => prevToasts.filter((toast) => toast.id !== id));
    }, []);

    return (
        <ToastContext.Provider value={{ addToast }}>
            {children}
            {toasts.map((toast, index) => (
                <Snackbar anchorOrigin={{vertical: "bottom", horizontal: "center"}}
                          key={toast.id ?? index}
                          open autoHideDuration={5000}
                          onClose={() => handleCloseSnackbar(toast.id as number)}
                          style={{ bottom: `${(index + 1) * 60}px` }}>
                    <Alert onClose={() => handleCloseSnackbar(toast.id as number)} severity={toast.type} style={{ width: '100%' }}>
                        {toast.message}
                    </Alert>
                </Snackbar>
            ))}
        </ToastContext.Provider>
    );
};

export default SnackbarToast;
